(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_29bf936"] && !Shopify.designMode) return;
  try {
    /*
   * Dupliceert de berichten tot de balk minstens 2x zo breed is als het scherm, en rekent
   * de animatieduur uit op basis van de breedte (gelijke snelheid, ongeacht aantal berichten).
   * De animatie zelf is pure CSS: translateX van 0 naar -50%. Daarom altijd een EVEN aantal
   * groepen, anders valt -50% midden in een groep en springt de balk aan het eind van de ronde.
   */
  if (!customElements.get('ai-announcement-ticker')) {
    class AiAnnouncementTicker extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('[data-ticker-viewport]');
        this.track = this.querySelector('[data-ticker-track]');
        this.source = this.querySelector('[data-ticker-source]');
        if (!this.viewport || !this.track || !this.source) return;

        this.lastWidth = 0;
        this.frame = null;
        this.desktopQuery = window.matchMedia('(min-width: 750px)');
        this.onQueryChange = () => this.setup(true);
        this.desktopQuery.addEventListener('change', this.onQueryChange);

        // Alleen opnieuw opbouwen als de balk echt van breedte verandert, max. 1x per frame.
        this.resizeObserver = new ResizeObserver(() => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = null;
            this.setup();
          });
        });
        this.resizeObserver.observe(this.viewport);

        this.setup(true);
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
        this.desktopQuery?.removeEventListener('change', this.onQueryChange);
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = null;
      }

      setup(force = false) {
        const viewportWidth = this.viewport.clientWidth;
        if (!viewportWidth || !this.source.children.length) return;
        if (!force && viewportWidth === this.lastWidth) return;
        this.lastWidth = viewportWidth;

        this.track.querySelectorAll('[data-ticker-clone]').forEach((clone) => clone.remove());

        const groupWidth = this.source.getBoundingClientRect().width;
        if (!groupWidth) return;

        let groups = Math.max(2, Math.ceil((viewportWidth * 2) / groupWidth));
        if (groups % 2) groups += 1;
        groups = Math.min(groups, 200);

        for (let i = 1; i < groups; i++) {
          const clone = this.source.cloneNode(true);
          clone.removeAttribute('data-ticker-source');
          clone.setAttribute('data-ticker-clone', '');
          clone.setAttribute('aria-hidden', 'true');
          clone.inert = true;
          this.track.appendChild(clone);
        }

        // Snelheid-instelling = seconden om één schermbreedte af te leggen.
        const seconds = Number(this.desktopQuery.matches ? this.dataset.speedDesktop : this.dataset.speed) || 25;
        const duration = (groupWidth * groups) / 2 / (viewportWidth / seconds);
        this.track.style.setProperty('--ai-ticker-duration', `${duration}s`);
      }
    }

    customElements.define('ai-announcement-ticker', AiAnnouncementTicker);
  }
  } catch(e) { console.error(e); }
})();

})();
